import { Column } from 'react-table'
import GetUrls from 'ts/enums/Url'
import { ProductCategory } from 'ts/types/ProductCategory'
import { Boolean as BooleanCell } from 'components/ui'
import CardTable from 'components/CardTable'
import ProductCategoryAddPage from './ProductCategoryAddPage'

const columns: Column<ProductCategory>[] = [
  {
    Header: 'ID',
    accessor: 'categoryId'
  },
  {
    Header: 'Active',
    accessor: 'isActive',
    Cell: ({ value }) => <BooleanCell value={value} />
  },
  {
    Header: 'Category',
    accessor: 'categoryName'
  }
]

const ProductCategoryPage = () => {
  const Url = GetUrls();
  return (
  <CardTable
    columns={columns}
    dataKey={Url.getCategory.toString()}
    url={Url.getCategory}
    listName={'categoryList'}
    modalChild={<ProductCategoryAddPage />}
  />
)}

export default ProductCategoryPage
